import { iconCertificate, iconCreditCard, iconInsurance, iconToogle } from 'assets/icons';
import { LINK_DEV } from 'constants';
import React from 'react';

export default function MenuHome() {
  return (
    <>
      <div className='wrap-menu-home'>
        <Item
          onClick={() => {
            window.open(`${LINK_DEV}/contract-query`);
          }}
          icon={iconCertificate}
          title={
            <>
              Truy vấn <br />
              hợp đồng
            </>
          }
        />
        <Item
          onClick={() => {
            window.open(`${LINK_DEV}/pages/premium-payment`);
          }}
          icon={iconCreditCard}
          title={
            <>
              Đóng phí <br />
              hợp đồng
            </>
          }
        />
        <Item
          onClick={() => {
            window.open(`${LINK_DEV}`);
          }}
          icon={iconToogle}
          title={
            <>
              Giao dịch
              <br /> online{' '}
            </>
          }
        />
        <Item
          onClick={() => {
            window.open(`${LINK_DEV}`);
          }}
          icon={iconInsurance}
          title={
            <>
              Giải quyết <br />
              quyền lợi
            </>
          }
        />
      </div>
    </>
  );
}

const Item = ({ onClick, icon, title }) => {
  return (
    <div className='wrap-menu-home-item' onClick={onClick}>
      <div className='wrap-menu-home-item-icon'>
        <img src={icon} />
      </div>
      <p className='wrap-menu-home-item-title'>{title}</p>
    </div>
  );
};
